const state = {
  categories: [],
  selectedCat: 'All Categories'
}

const mutations = {
  setCategories: function (state, payload) {
    state.categories = payload
  },
  setSelectedCat: function (state, payload) {
    state.selectedCat = payload
  }
}

const actions = {
  loadCategories: function (context, categories) {
    context.commit('setCategories', categories)
  },
  loadSelectedCat: function (context, category) {
    context.commit('setSelectedCat', category)
  },
  createCategories: function (context) {
    var unique = {}
    var distinct = []
    distinct.push('All Categories')
    var athletes = context.getters.athletes
    for (let i in athletes) {
      if (typeof (unique[athletes[i].category]) === 'undefined') {
        distinct.push(athletes[i].category)
      }
      unique[athletes[i].category] = 0
    }
    context.commit('setCategories', distinct)
  }
}

const getters = {
  categories: state => {
    return state.categories
  },
  selectedCat: state => {
    return state.selectedCat
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/categories.js